//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TelephoneInformationInputItem } from './TelephoneInformationInputItem';

export class AdultInputItem extends ItemBase {
    Address: string | null = null;
    IncludeInContactList: boolean = false;
    PreferredInvoiceRecipient: boolean = false;
    TelephoneHome: TelephoneInformationInputItem | null = null;
    TelephoneWork: TelephoneInformationInputItem | null = null;
    Title: string | null = null;

    constructor(initializer?: Partial<AdultInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AdultInputItem";
}
